// TRAD-2599 배치3 — 지역명 공유 카탈로그.
//
// 4개 화면(real-estate-community-write-page / real-estate-community-list-page /
// subscriptions-page / subscription-score-page)이 같은 17개 지역명을 각자
// 하드코딩(KO)으로 들고 있었다. 이 파일이 정본이다 — 화면은 이 상수를 조합만
// 하고, 매핑 자체를 다시 만들지 않는다.
//
// 🔴 두 종류의 "데이터"가 섞여 있었다는 게 이 설계의 핵심이다:
//   - write/list 페이지는 국토부 LAWD_CD 스타일 숫자 code를 서버로 보낸다.
//   - subscriptions/subscription-score 페이지는 **한글 지역명 문자열 자체**를
//     서버로 보낸다(예: `region: "서울"`이 그대로 쿼리 파라미터). 이 두 화면엔
//     애초에 code 개념이 없다.
// 표시(번역)와 데이터(code/apiName)를 분리하지 않으면, 나중에 누가 KO 카피를
// 다듬는 순간 API 계약이 조용히 깨진다 — 화면은 멀쩡해 보이고 검색 결과만
// 0건이 된다.
//
// 🔴 TRAD-2604 — 전북(전라북도) 코드가 `52`로 잘못 박혀 있었다. 국토부 실거래가
// API의 LAWD_CD는 특별자치도 전환 이후에도 구코드 체계를 그대로 쓴다(명칭만
// 바뀌었을 뿐 법정동코드는 안 바뀜) — 서버 region_code 테이블도 `45`로 통일돼
// 있다. dev 직접 호출로 parentCode=45 → 14개 결과 / 52 → 0개 결과 확인됨.
// 여기서 45로 고친다 — write/list 2파일만 이 버그의 영향을 받았다(subscriptions
// 계열은 code가 없어 애초에 안전했다).
// 🔴 `apiName`은 서버로 나가는 데이터다. 표시용이 아니며 번역·수정 금지 —
// subscriptions/subscription-score 페이지가 이 값을 쿼리 파라미터로 그대로
// 보낸다. 화면에 보여줄 문구가 필요하면 `key`로 `t()`를 거쳐라. 이 값 자체를
// "개선"(예: "서울"→"서울특별시")하면 그 두 화면의 지역 필터가 조용히
// 깨진다(검색 결과 0건, 에러는 안 남) — regions.test.ts가 17개 값을 그대로
// 고정해 이 회귀를 잡는다.
export const REGIONS = [
  { code: '11', apiName: '서울', key: 'region.seoul' },
  { code: '41', apiName: '경기', key: 'region.gyeonggi' },
  { code: '28', apiName: '인천', key: 'region.incheon' },
  { code: '26', apiName: '부산', key: 'region.busan' },
  { code: '27', apiName: '대구', key: 'region.daegu' },
  { code: '29', apiName: '광주', key: 'region.gwangju' },
  { code: '30', apiName: '대전', key: 'region.daejeon' },
  { code: '31', apiName: '울산', key: 'region.ulsan' },
  { code: '36', apiName: '세종', key: 'region.sejong' },
  { code: '42', apiName: '강원', key: 'region.gangwon' },
  { code: '43', apiName: '충북', key: 'region.chungbuk' },
  { code: '44', apiName: '충남', key: 'region.chungnam' },
  { code: '45', apiName: '전북', key: 'region.jeonbuk' }, // TRAD-2604 — 52 아님
  { code: '46', apiName: '전남', key: 'region.jeonnam' },
  { code: '47', apiName: '경북', key: 'region.gyeongbuk' },
  { code: '48', apiName: '경남', key: 'region.gyeongnam' },
  { code: '50', apiName: '제주', key: 'region.jeju' },
] as const;

/** 조회(목록) 화면 전용 — 작성 화면에는 없다("선택 안함"이 그 자리를 대신함). */
export const REGION_ALL = { code: '', apiName: '', key: 'region.all' } as const;

/** code/apiName은 데이터, key는 `t()`로 넘길 리터럴 문자열 유니온 — 4파일 공통 타입. */
export type RegionOption = (typeof REGIONS)[number] | typeof REGION_ALL;
